export const MAX_SCENE_ASSETS = 100;
export const UNDO_STACK_SIZE = 100;
export const CANVAS_PRESETS = {
    '1920x1080': { width: 1920, height: 1080, label: '1920 × 1080 (Full HD)' },
    '1280x720': { width: 1280, height: 720, label: '1280 × 720 (HD)' },
    '2560x1440': { width: 2560, height: 1440, label: '2560 × 1440 (QHD)' },
};
export const DEFAULT_CANVAS_WIDTH = 1920;
export const DEFAULT_CANVAS_HEIGHT = 1080;
export const DEFAULT_CANVAS_BG = '#1a1a2e';
export const SUPPORTED_SPINE_VERSIONS = ['4.2', '4.1', '3.8'];
export const SPINE_VERSION_LABELS = {
    '4.2': 'Spine 4.2 (Primary)',
    '4.1': 'Spine 4.1 (Compat)',
    '3.8': 'Spine 3.8 (Legacy V2)',
};
export const DEFAULT_FPS = 30;
export const DEFAULT_PLAYBACK_SPEED = 1;
export const MIN_PLAYBACK_SPEED = 0.25;
export const MAX_PLAYBACK_SPEED = 4;
export const AUTOSAVE_DEBOUNCE_MS = 5000;
export const DEFAULT_GRID_SIZE = 50;
export const DEFAULT_LAYER = {
    visible: true,
    locked: false,
    opacity: 1.0,
    skin: 'default',
};
export const ASSET_REQUIRED_EXTENSIONS = ['.json', '.atlas'];
export const ASSET_PNG_EXTENSION = '.png';
export const JWT_EXPIRY_SECONDS = 60 * 60 * 24 * 7; // 7 days
export const SHARE_TOKEN_LENGTH = 32;
